import React from "react";
import { Loader2 } from "lucide-react";

export interface ThemeLoaderProps {
  size?: number;
  className?: string;
}

export const ThemeLoader: React.FC<ThemeLoaderProps> = ({ size = 16, className = "" }) => {
  return (
    <Loader2 
      size={size} 
      className={`animate-spin text-brand ${className}`}
    />
  );
};
